const getImagePathFromName = (img?: string) => {
  if (img?.startsWith('/uploads') || img?.startsWith('uploads') || img?.startsWith('/blog') || img?.startsWith('blog')) {
    // add REACT_APP_CONTENT_URL to the BO and B2C env
    return `${process.env.REACT_APP_CONTENT_URL}${img}`;
  }
  return img ?? '';
};

export default getImagePathFromName;
